/**
 * Generate a new UUID for entries
 */
export const newId = (): string => crypto.randomUUID();

/**
 * Get current timestamp in ISO format
 */
export const now = (): string => new Date().toISOString();

/**
 * Build a 4-part IndexedDB key: {projectName}/{rootTag}/{fileId}/{itemId}
 */
export const buildKey = (projectName: string, rootTag: string, fileId: string, itemId: string): string => {
  return `${projectName}/${rootTag}/${fileId}/${itemId}`;
};

/**
 * Parse a 4-part key back into its components
 */
export const parseKey = (key: string): { projectName: string; rootTag: string; fileId: string; itemId: string } | null => {
  const parts = key.split("/");
  if (parts.length !== 4) return null;
  return {
    projectName: parts[0],
    rootTag: parts[1],
    fileId: parts[2],
    itemId: parts[3],
  };
};

/**
 * Get a prefix to query all items of a type in a file
 */
export const getFilePrefix = (projectName: string, rootTag: string, fileId: string): string => {
  return `${projectName}/${rootTag}/${fileId}/`;
};

/**
 * Get a prefix to query all items of a type across all files in a project
 */
export const getProjectTypePrefix = (projectName: string, rootTag: string): string => {
  return `${projectName}/${rootTag}/`;
};

/**
 * Get a prefix to query all items in a project
 */
export const getProjectPrefix = (projectName: string): string => {
  return `${projectName}/`;
};
